<template>
  <div class="frame" :style="{height:frameHeight+'px', width: frameWidth+'px', zoom: zoom, background: bgColor}">
      <div :style="divStyle">
        <img class="image" :src="img" :style="imgStyle">
      </div>
    </div>
</template>

<script>
export default {
  components: {

  },
  props: [
    'img',
    'scale',
    'imgX',
    'imgY',
    'imgTrueWidth',
    'imgTrueHeight',
    'cropX',
    'cropY',
    'cropW',
    'cropH',
    'frameX',
    'frameY',
    'frameWidth',
    'frameHeight',
    'bgColor',
    'zoom'
  ],
  data () {
    return {

    }
  },
  computed: {
    divStyle () {
      return {
        position: 'relative',
        left: `${this.cropX - this.frameX}px`,
        top: `${this.cropY - this.frameY}px`,
        width: `${this.cropW}px`,
        height: `${this.cropH}px`,
        overflow: 'hidden'
      }
    },
    imgStyle () {
      const transformX = (this.imgX - this.cropX) / this.scale
      const transformY = (this.imgY - this.cropY) / this.scale
      return {
        width: `${this.imgTrueWidth}px`,
        height: `${this.imgTrueHeight}px`,
        transform: `scale(${this.scale}) translate3d(${transformX}px, ${transformY}px, 0px) rotateZ(0deg)`
      }
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.frame{background:#fff; position: relative; margin: 0 auto;box-shadow:0 0 20px #ccc;}
</style>



// WEBPACK FOOTER //
// src/pages/design/Preview.vue